import { Component, OnInit, OnDestroy, Output, EventEmitter, inject } from '@angular/core';
import { ControlContainer, FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OpenDialogService } from '@core/services/open-dialog.service';
import { ErrorStateOnTouched } from '@app/material/ErrorStateOnTouched';
import { MobilePhoneFormControls } from '@sales/modules/mobilephone/components/mobilephone-search/mobilephone-details/mobilephone-details.component';
import { Subscription } from 'rxjs/internal/Subscription';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { IconNames } from '@app/shared/enums/icon-names';
import { focusHtmlElementById } from '@app/core/utils';
import { FormValidationService } from '@app/shared/services/form-validation.service';
import { MatIcon } from '@angular/material/icon';
import { IceInputFieldComponent } from '@app/shared/components/molecules/ice-input-field/ice-input-field.component';

@Component({
  selector: 'app-mobilephone-gtin-scan',
  templateUrl: './mobilephone-gtin-scan.component.html',
  styleUrls: ['./mobilephone-gtin-scan.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  imports: [IceInputFieldComponent, FormsModule, ReactiveFormsModule, MatIcon],
})
export class MobilephoneGtinScanComponent implements OnInit, OnDestroy {
  private formGroupDirective = inject(FormGroupDirective);
  openDialogService = inject(OpenDialogService);

  MobilePhoneFormControls = MobilePhoneFormControls;
  getImeiErrorText = FormValidationService.getImeiErrorText;

  @Output() gtinScanned = new EventEmitter<string>();
  IconNames = IconNames;

  toolTipText = 'Mer info';

  form: FormGroup;
  matcher = new ErrorStateOnTouched();
  imeiElementId = 'imeiScanInput';

  subscriptions$: Subscription[] = [];

  get gtinControl() {
    return this.form.get(MobilePhoneFormControls.Gtin);
  }

  get imeiControl() {
    return this.form.get(MobilePhoneFormControls.Imei);
  }

  ngOnInit() {
    this.form = this.formGroupDirective.form;

    this.subscriptions$.push(
      this.gtinControl.valueChanges
        .pipe(
          debounceTime(400),
          distinctUntilChanged(),
          tap(gtin => {
            if (this.gtinControl.invalid) {
              return;
            }

            this.gtinScanned.emit(gtin);
          })
        )
        .subscribe()
    );
  }

  focusImeiField(event: Event) {
    event.preventDefault();
    focusHtmlElementById(this.imeiElementId);
  }

  ngOnDestroy() {
    this.subscriptions$.forEach(subscription => subscription.unsubscribe());
  }
}
